import { format } from 'date-fns'
import { es } from 'date-fns/locale'
import { FilterX, X } from 'lucide-react'
import { DateRange } from 'react-day-picker'

import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { useState } from 'react'

interface Props {
  filter: Record<string, string>
  removeFilter: (key: string) => void
  removeAllFilters: () => void
}
export const SelectionSummary = ({filter, removeFilter, removeAllFilters}: Props) => {
  return (
    <div className="mt-2 flex flex-wrap gap-2">
      {Object.entries(filter || {}).map(([key, value], idx) => (
        <Badge
          key={key + idx.toString()}
          variant="secondary"
          className="gap-1 rounded-full py-1.5 pl-2 pr-1"
        >
          <span>
            {key}: {value}
          </span>
          <Button
            variant="ghost"
            size="icon"
            className="ml-1 h-4 w-4"
            onClick={() => removeFilter(key)}
          >
            <X className="h-3 w-3" />
          </Button>
        </Badge>
      ))}
      <Button
        variant="ghost"
        size="sm"
        className="h-7 gap-1 text-xs"
        onClick={removeAllFilters}
      >
        <FilterX className="h-3.5 w-3.5" />
        Limpiar filtros
      </Button>
    </div>
  )
}
